var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useMutation } from '@apollo/client';
import { callSideEffects } from '../../util';
const SIGN_IN_MUTATION = gql `
    mutation SignIn($request: SignInRequest!) {
        signIn(request: $request) {
            title
            firstName
            lastName
            phoneNumber
            address
            postalCode
            country
            email
        }
    }
`;
export function useSignIn(sideEffects) {
    const [signInMutation, signInState] = useMutation(SIGN_IN_MUTATION);
    const signIn = (email, password) => __awaiter(this, void 0, void 0, function* () {
        const { data: signInResponse } = yield signInMutation({ variables: { request: { email, password } } });
        if (signInResponse === null || signInResponse === void 0 ? void 0 : signInResponse.signIn) {
            callSideEffects(sideEffects, signInResponse.signIn);
        }
    });
    return { signInState, signIn };
}
